import React, { ReactNode } from 'react'
import Button from '../../../components/common/Button'
import styled from '@emotion/styled'
import { Authorize } from '../../../components/Authorize'
import { ROLE } from '../../../services/user/user-typed'

const Layout = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding-right: 16px;
  margin-top: 16px;
`

const ButtonStyled = styled(Button)`
  padding: 7px 13px;
`

type Props = {
  editMode: boolean
  isDisabledOnSubmit?: boolean
  onSubmit: () => void
  onCancel: () => void
}

const CategoryTableBottombar = (props: Props) => {
  const { editMode, onSubmit, onCancel, isDisabledOnSubmit = false } = props
  return (
    <Layout>
      <Authorize role={ROLE.MANAGER}>
        {editMode && (
          <div style={{ display: 'flex', gap: '8px' }}>
            <ButtonStyled variant="primary" onClick={onSubmit} disabled={isDisabledOnSubmit}>
              Submit
            </ButtonStyled>
            <ButtonStyled variant="danger" onClick={onCancel}>
              Cancel
            </ButtonStyled>
          </div>
        )}
      </Authorize>
    </Layout>
  )
}

export default CategoryTableBottombar
